import { render, staticRenderFns } from "./psnpayrollNew.vue?vue&type=template&id=d6ec2ef2"
import script from "./psnpayrollNew.vue?vue&type=script&lang=js"
export * from "./psnpayrollNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports